import { Injectable } from '@angular/core';
import { catchError , retry } from 'rxjs/internal/operators';
import { Observable } from 'rxjs';
import { HttpClientModule,HttpHeaders,HttpClient, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { CartProduct, Product } from '../classes/orders';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';

@Injectable({
	providedIn: 'root'
})

@Injectable({
	providedIn: 'root'
})
export class WarehouseService {
	key = 'UET6DFMPAXW7BKCB';
	items: Product[] = [];
	config: any;
	user : any = [];
	constructor(private http: HttpClient,private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})

		this.globalSearchService.user.subscribe( (result: any) => {
			this.user = result;
		});
	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type':	'application/json',
		})
	};



	public saveQuote(customer: any, items: any,totals: any, user:any) {
		const method = 'warehouse/savequote';
		 return this.http.post(this.setEndPoint(method), { customer:customer, items: items } , this.httpOptions).pipe(
			 catchError(this.handleError(method, customer))
		 );
	}

	public getDashBaord() {
		const method = 'warehouse/dashboard';
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * Board rollup — one row per open order plus floor stats and the day's cutoff
	 * deadlines. `stage` picks which counter it measures: 'pick' is picked
	 * against pick, 'check' is loaded against picked. Read-only; the counting
	 * writes still go over the socket.
	 */
	public getPickBoard(loccode: any = '', stage: any = 'pick') {
		let method = 'warehouse/pickboard/board&stage=' + encodeURIComponent(stage);
		if (loccode && loccode !== '') {
			method += '&loccode=' + encodeURIComponent(loccode);
		}
		return this.http.get(this.setEndPoint(method));
	}

	/** Header + bin-sorted lines for one order, for the pick / check station. */
	public getPickOrder(orderno: any, stage: any = 'pick') {
		const method = 'warehouse/pickboard/order&orderno=' + encodeURIComponent(orderno)
			+ '&stage=' + encodeURIComponent(stage);
		return this.http.get(this.setEndPoint(method));
	}

	/** What the floor screens are allowed to do — auto-invoice flags, roll width. */
	public getPickSettings() {
		const method = 'warehouse/pickboard/settings';
		return this.http.get(this.setEndPoint(method));
	}

	/**
	 * Called after a stage is closed out. The server decides whether this order
	 * invoices itself; a refusal comes back as success with a `reason`, not an
	 * error, so the station can say why in plain words.
	 */
	public finalizeStage(orderno: any, stage: any) {
		const method = 'warehouse/pickboard/finalize';
		return this.http.post(this.setEndPoint(method), { orderno, stage }, this.httpOptions).pipe(
			catchError(this.handleError(method, orderno))
		);
	}

	/** Claim (or release) an order so two pickers don't walk the same aisles. */
	public claimPickOrder(orderno: any, userid: any, release = false) {
		const method = 'warehouse/pickboard/claim';
		return this.http.post(this.setEndPoint(method), { orderno, userid, release }, this.httpOptions).pipe(
			catchError(this.handleError(method, orderno))
		);
	}

	private setEndPoint(method: any) {
		return this.getApi()+method+this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		 return '&key='+this.config.apiCredentials.clientId+'&userid='+this.user.user.userid;
	}

	public getKey() {
		return '&apikey='+this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			return error;
		};
	}

}
